export enum TermsPageSource {
  PromotionPlanSelectionModal = 'promotion_plan_selection_modal',
  PromotionPlanPaymentForm = 'promotion_plan_payment_form',
  MiniPromotionPlanOfferModal = 'mini_promotion_plan_offer_modal',
  ListingUploadPromotionPlanStep = 'listing_upload_promotion_plan_step',
}

export enum TermsPageSectionId {
  PrivateListingPromotionPlanTerms = 'private-listing-promotion-plan-terms',
}
